module.exports = __webpack_public_path__ + "media/assets/images/layout/body-bg-toast-dark-40156fd22ffdb9b24f7090820669a2fd.png";